"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SortsV3Service", {
    enumerable: true,
    get: function() {
        return SortsV3Service;
    }
});
const _common = require("@nestjs/common");
const _models = require("~/models");
const _sortsservice = require("~/services/sorts.service");
const _apiv3datatransformationbuilder = require("~/utils/api-v3-data-transformation.builder");
const _catchError = require("~/helpers/catchError");
const _helpers = require("~/helpers");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let SortsV3Service = class SortsV3Service {
    async sortGet(context, param) {
        return (0, _apiv3datatransformationbuilder.sortBuilder)().build(await this.sortsService.sortGet(context, param));
    }
    async sortDelete(context, param, ncMeta = _Noco.default.ncMeta) {
        var _param_sortId;
        const sort = await _models.Sort.get(context, (_param_sortId = param.sortId) != null ? _param_sortId : '', ncMeta);
        if (!sort || sort.fk_view_id !== param.viewId) {
            _catchError.NcError.notFound('Sort not found');
        }
        await this.sortsService.sortDelete(context, param, ncMeta);
        return {};
    }
    async sortUpdate(context, param, ncMeta = _Noco.default.ncMeta) {
        (0, _helpers.validatePayload)('swagger-v3.json#/components/schemas/SortUpdate', param.sort, true);
        let sort;
        if (param.sortId) {
            sort = await _models.Sort.get(context, param.sortId, ncMeta);
        } else {
            const sorts = await _models.Sort.list(context, {
                viewId: param.viewId
            }, ncMeta);
            sort = sorts.find((s)=>s.fk_column_id === param.sort.field_id);
        }
        if (!sort || sort.fk_view_id !== param.viewId) {
            _catchError.NcError.notFound('Sort not found');
        }
        const updateObj = this.revBuilder().build(param.sort);
        await this.sortsService.sortUpdate(context, _extends({}, param, {
            sortId: sort.id,
            sort: updateObj,
            viewWebhookManager: param.viewWebhookManager
        }), ncMeta);
        return this.sortGet(context, param);
    }
    async sortCreate(context, param, ncMeta = _Noco.default.ncMeta) {
        (0, _helpers.validatePayload)('swagger-v3.json#/components/schemas/SortCreate', param.sort, true, context);
        // check for existing filter with same field
        const sorts = await _models.Sort.list(context, {
            viewId: param.viewId
        }, ncMeta);
        const existingSort = sorts.find((s)=>s.fk_column_id === param.sort.field_id);
        if (existingSort) {
            _catchError.NcError.get(context).invalidRequestBody('Sort already exists for this field');
        }
        // check column exists
        const column = await _models.Column.get(context, {
            colId: param.sort.field_id
        }, ncMeta);
        if (!column) {
            _catchError.NcError.get(context).notFound('Column not found');
        }
        const sort = await this.sortsService.sortCreate(context, _extends({}, param, {
            sort: this.revBuilder().build(param.sort),
            viewWebhookManager: param.viewWebhookManager
        }), ncMeta);
        return (0, _apiv3datatransformationbuilder.sortBuilder)().build(sort);
    }
    async sortList(context, param, ncMeta = _Noco.default.ncMeta) {
        return (0, _apiv3datatransformationbuilder.sortBuilder)().build(await _models.Sort.list(context, {
            viewId: param.viewId
        }, ncMeta));
    }
    constructor(sortsService){
        this.sortsService = sortsService;
        this.revBuilder = (0, _apiv3datatransformationbuilder.builderGenerator)({
            allowed: [
                'id',
                'field_id',
                'direction'
            ],
            mappings: {
                field_id: 'fk_column_id'
            }
        });
    }
};
SortsV3Service = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _sortsservice.SortsService === "undefined" ? Object : _sortsservice.SortsService
    ])
], SortsV3Service);
